// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"7a10e07a","455":"54ac6041","857":"288f5589","977":"695e63e9"}[chunkId] + ".chunk.js";
};